"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
require("./styles/index.less");

var styles = {
  "screenSmMax": "767px",
  "wrapper": "meepshop-thumbnail__index__wrapper",
  "image": "meepshop-thumbnail__index__image"
}; // graphql typescript

// definition
var _default = function _default(_ref) {
  var image = _ref.image,
      className = _ref.className,
      source = _ref.source,
      mobileSize = _ref.mobileSize,
      size = _ref.size,
      disableRound = _ref.disableRound,
      disableShadow = _ref.disableShadow,
      onClick = _ref.onClick;

  var _useContext = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext.colors;

  var backgroundImage = (0, _react.useMemo)(function () {
    var _image$scaledSrc, _image$scaledSrc2;

    if (!(image !== null && image !== void 0 && image.imageExists)) return "url(".concat(require("@meepshop/images/lib/getImage")["default"]({
      stage: "https://img.meepstage.com/SZ_dAEBQj9Kuu2nMhtpvEJkIYrD_yYsJH0j_XfA0b7w/w:120/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
      production: "https://img.meepshop.com/IBmAFppYK6XalNiYfk-4RYfAPnB31FFtLDezPoYSRtM/w:120/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
    }), ")");
    if (image !== null && image !== void 0 && (_image$scaledSrc = image.scaledSrc) !== null && _image$scaledSrc !== void 0 && _image$scaledSrc[source || 'w120']) return "url(".concat(image === null || image === void 0 ? void 0 : (_image$scaledSrc2 = image.scaledSrc) === null || _image$scaledSrc2 === void 0 ? void 0 : _image$scaledSrc2[source || 'w120'], ")");
    return "url(".concat(require("@meepshop/images/lib/getImage")["default"]({
      stage: "https://img.meepstage.com/SZ_dAEBQj9Kuu2nMhtpvEJkIYrD_yYsJH0j_XfA0b7w/w:120/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA",
      production: "https://img.meepshop.com/IBmAFppYK6XalNiYfk-4RYfAPnB31FFtLDezPoYSRtM/w:120/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGxhY2Vob2xkZXIvdGh1bWJuYWlsLndlYnA"
    }), ")");
  }, [image, source]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.wrapper, " ").concat(className || ''),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.image,
    style: {
      backgroundImage: backgroundImage
    }
  })), /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n              .".concat(styles.wrapper).concat(className ? ".".concat(className) : '', " {\n                width: ").concat(size, "px;\n                height: ").concat(size, "px;\n                border-radius: ").concat(disableRound ? 0 : 5, "px;\n                outline: ").concat(disableShadow ? 'none' : "1px solid ".concat((0, _color["default"])(colors[3]).alpha(0.1).toString()), ";\n                box-shadow: ").concat(disableShadow ? 'none' : "0px 1px 3px ".concat((0, _color["default"])(colors[3]).alpha(0.08).toString()), "\n              }\n\n              @media (max-width: ").concat(styles.screenSmMax, ") {\n                .").concat(styles.wrapper).concat(className ? ".".concat(className) : '', " {\n                  width: ").concat(mobileSize, "px;\n                  height: ").concat(mobileSize, "px;\n                }\n              }\n            ")
    }
  }));
};

exports["default"] = _default;